module.exports = __webpack_public_path__ + "static/siili-02cd04836e619d866233a67e388d7573.svg";